/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { useState, ReactElement } from "react";
import { CommandBar, Stack } from "@fluentui/react";
import { UpdateSARegistrationStatusSidePanel } from "Components/UpdateSARegistrationStatusSidePanel/UpdateSARegistrationStatusSidePanel";
import { UpdateSAProgramStatusSidePanel } from "Components/UpdateSAProgramStatusSidePanel/UpdateSAProgamStatusSidePanel";
import {
  updateCommandBarStyles,
  commandBarStyles,
} from "Components/UpdateSARegistrationStatus/UpdateSARegistrationStatus.styles";

/**
 * Update Student Ambassador Registration Status.
 * @returns ReactElement
 */
const UpdateSARegistrationStatus = (): ReactElement => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const [isProgramStatusPanelOpen, setIsProgramStatusPanelOpen] = useState(false);

  const updateRegistrationStatusClicked = (): void => {
    setIsPanelOpen(true);
  };

  const updateProgramStatusClicked = (): void => {
    setIsProgramStatusPanelOpen(true);
  };

  /**
   * command Bar Items.
   */
  const commandBarItems = [
    {
      key: "updateRegistrationStatus",
      text: "Update Registration Status",
      iconProps: { iconName: "Edit" },
      onClick: (): void => {
        updateRegistrationStatusClicked();
      },
    },
    {
      key: "updateProgramStatus",
      text: "Update Program Status",
      iconProps: { iconName: "Edit" },
      onClick: (): void => {
        updateProgramStatusClicked();
      },
    },
  ];

  return (
    <>
      <Stack styles={updateCommandBarStyles}>
        {
          <CommandBar
            items={commandBarItems}
            ariaLabel="Update Registration Status"
            styles={commandBarStyles}
          />
        }
      </Stack>
      {isPanelOpen && (
        <UpdateSARegistrationStatusSidePanel
          isPanelOpen={isPanelOpen}
          setIsPanelOpen={setIsPanelOpen}
        />
      )}
      {isProgramStatusPanelOpen && (
        <UpdateSAProgramStatusSidePanel
          isPanelOpen={isProgramStatusPanelOpen}
          setIsPanelOpen={setIsProgramStatusPanelOpen}
        />
      )}
    </>
  );
};

export default UpdateSARegistrationStatus;
